export default __webpack_public_path__ + "aeb30b3.png";